var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobilephone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 24,
    viewBox: "0 0 15 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7 21.6C8.7 21.1875 8.55313 20.8344 8.25938 20.5406C7.96563 20.2469 7.6125 20.1 7.2 20.1C6.7875 20.1 6.43438 20.2469 6.14063 20.5406C5.84688 20.8344 5.7 21.1875 5.7 21.6C5.7 22.0125 5.84688 22.3656 6.14063 22.6594C6.43438 22.9531 6.7875 23.1 7.2 23.1C7.6125 23.1 7.96563 22.9531 8.25938 22.6594C8.55313 22.3656 8.7 22.0125 8.7 21.6ZM12.6 18.6V5.4C12.6 5.2375 12.5406 5.09688 12.4219 4.97813C12.3031 4.85938 12.1625 4.8 12 4.8H2.4C2.2375 4.8 2.09688 4.85938 1.97813 4.97813C1.85938 5.09688 1.8 5.2375 1.8 5.4V18.6C1.8 18.7625 1.85938 18.9031 1.97813 19.0219C2.09688 19.1406 2.2375 19.2 2.4 19.2H12C12.1625 19.2 12.3031 19.1406 12.4219 19.0219C12.5406 18.9031 12.6 18.7625 12.6 18.6ZM9 2.7C9 2.5 8.9 2.4 8.7 2.4H5.7C5.5 2.4 5.4 2.5 5.4 2.7C5.4 2.9 5.5 3 5.7 3H8.7C8.9 3 9 2.9 9 2.7ZM14.4 2.4V21.6C14.4 22.25 14.1625 22.8125 13.6875 23.2875C13.2125 23.7625 12.65 24 12 24H2.4C1.75 24 1.1875 23.7625 0.7125 23.2875C0.2375 22.8125 0 22.25 0 21.6V2.4C0 1.75 0.2375 1.1875 0.7125 0.7125C1.1875 0.2375 1.75 0 2.4 0H12C12.65 0 13.2125 0.2375 13.6875 0.7125C14.1625 1.1875 14.4 1.75 14.4 2.4Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobilephone);
export default __webpack_public_path__ + "static/media/mobilephone.9f74890d51a1975519fb735fa2c806ba.svg";
export { ForwardRef as ReactComponent };